import { FunctionComponent, useState } from "react";
import { Check, Copy } from "lucide-react";
import "./CopyableInput.scss";

interface CopyableInputProps {
    value: string;
    /** Tempo em ms para mostrar o estado "copiado" (default 1500) */
    copiedDuration?: number;
    /** Texto exibido no estado "copiado" (default "copiado!") */
    copiedLabel?: string;
    /** Mostrar so o input ou tambem um botao com icone */
    showIcon?: boolean;
    className?: string;
    /** Callback opcional apos copiar */
    onCopy?: (value: string) => void;
}

const CopyableInput: FunctionComponent<CopyableInputProps> = ({
    value,
    copiedDuration = 1500,
    copiedLabel = "copiado!",
    showIcon = true,
    className = "",
    onCopy,
}) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(value);
        } catch {
            // fallback para browsers antigos
            const ta = document.createElement("textarea");
            ta.value = value;
            ta.style.position = "fixed";
            ta.style.opacity = "0";
            document.body.appendChild(ta);
            ta.select();
            try { document.execCommand("copy"); } catch {}
            document.body.removeChild(ta);
        }
        setCopied(true);
        onCopy?.(value);
        setTimeout(() => setCopied(false), copiedDuration);
    };

    return (
        <div className={`ui-copyable ${copied ? "is-copied" : ""} ${className}`.trim()}>
            <input
                type="text"
                readOnly
                value={copied ? copiedLabel : value}
                onClick={handleCopy}
                title="Clique para copiar"
            />
            {showIcon && (
                <button
                    type="button"
                    className="ui-copyable-btn"
                    onClick={handleCopy}
                    aria-label="Copiar"
                >
                    {copied ? <Check size={14} /> : <Copy size={14} />}
                </button>
            )}
        </div>
    );
};

export default CopyableInput;
